import { useEffect, useRef } from "react";

export const useScrollRef = (dataLength: number) => {
    const lastItemRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);
    const prevDataCountRef = useRef(dataLength);

    useEffect(() => {
        if (dataLength > prevDataCountRef.current && lastItemRef.current) {
            lastItemRef.current.scrollIntoView({ behavior: "smooth" });
        }
        prevDataCountRef.current = dataLength;
    }, [dataLength]);

    const handleScroll = () => {
        setTimeout(() => {
            if (contentRef.current) {
                contentRef.current.scrollTop = contentRef.current.scrollHeight;
            }
        }, 100);
    };

    return {
        contentRef,
        handleScroll,
        lastItemRef,
    };
};
